import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function(props) {
  const { title, subtitle, subtitle2} = props;

  return (
    <div>
      <div>
        <Typography
          style={{ fontWeight: 'bold', color: '#10587f', fontSize: 32, lineHeight: 'normal'}}
        >
          {title}
        </Typography>
        <Typography
          style={{ fontWeight: 'normal', color: '#10587f', fontSize: 18, lineHeight: 'normal' }}
        >
          {subtitle}
        </Typography>
        <Typography
          style={{ fontWeight: 'normal', color: '#10587f', fontSize: 18, lineHeight: 'normal' }}
        >
          {subtitle2}
        </Typography>
      </div>
      {props.children}
    </div>
  );
}
